import React, { Component } from 'react';
import social from './imagen/fb-ft.png';
export class FooterContactoQuadrum extends Component {

    render() {
        return   <div className="p-grid">

        <div className="p-col-12 p-md-1"></div>
        <div className="p-col-12 p-md-3">
            <center>
                <strong> Redes sociales</strong>
                <br /> <br /><img style={{ maxWidth: '50%', maxHeight: 'auto' }} src={social} alt="social" />
                <span>  <a style={{ color: '#000000' }} href="https://www.facebook.com/grup0quadrum?ref=ts&fref=ts" target="_blank" rel="noopener noreferrer" > Facebook</a></span>
            </center>
        </div>
        <div className="p-col-12 p-md-3">
            <center>
                <strong >Contacto</strong>
                <br /> <br /><span>Calle Montecito 38, Piso 25 22, Napoles DF, CP 03810</span>
                <br /> <br /><strong>Envíanos un email</strong><br />

                <ul style={{ textAlign: 'justify' }}>
                    <li>contacto@quadrum.com.mx</li>
                    <li>soportecapufe@quadrum.mx</li>
                </ul>
            </center>
        </div>
        <div className="p-col-12 p-md-3">
            
        </div>
        <div className="p-col-12 p-md-1"></div>

    </div>

    }
}